import { setSelectedSettingsLocations } from './chunk-JMA3A6L2.mjs';

// src/helpers/settings/modals/selectCustomersLocationModal.ts
var shouldShowCustomersLocationsModalOnSaveCore = (dispatch) => {
  dispatch(setSelectedSettingsLocations([]));
  return false;
};

export { shouldShowCustomersLocationsModalOnSaveCore };
